module.exports = __webpack_public_path__ + "img/havanna_oak_694m_list.923cba13.jpg";